A cover letter specific to a position opening.
